import { useRootLoader } from 'src/storage'

export const useAwsGateLoader = (gateId: string) => {
  return useRootLoader(gateId)
}
